angular.module('unica_media.media_controllers')

.controller('MediaListController', function(
	$rootScope, $scope, $state, $stateParams,
	$confirm, $uibModal, Lightbox,
	MediaListService, MediaDeleteService, MediaEditService
) {

	$scope.mediaList = [];
	$scope.limit  = 11;
	$scope.offset = 0;
	$scope.canLoad = true;
	$scope.event_id = $stateParams.event_id;
	$scope.directory_id = $stateParams.directory_id;

	$rootScope.getEvent( $stateParams.event_id );

	$rootScope.getMediaDirectory( $stateParams.directory_id );

	$scope.tiles = [];

	$scope.loadMedia = function() {
		$scope.showLoader();
		$scope.canLoad = false;

		MediaListService
			.list( $stateParams.event_id, $scope.directory_id, $scope.limit, $scope.offset )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					$scope.mediaList = $scope.mediaList.concat( data );

					$scope.tiles = $scope.tiles.concat( buildGridModel(data, {
						id: '', image : '', title: '', status: ''
					}) );

					if ( data.length === 0 ) {
						$scope.canLoad = false;
					} else {
						$scope.canLoad = true;
						$scope.offset = $scope.offset + data.length;
					}
				}
			});
	};

	$scope.loadMedia();

	$scope.openMediaModal = function () {
		var modalInstance = $uibModal.open({
			ariaLabelledBy: 'modal-title',
			ariaDescribedBy: 'modal-body',
			controller: 'ModalMediaInstanceController',
			controllerAs: '$ctrl',
			templateUrl: './templates/modals/media.html',
			size: 'lg',
			windowClass: 'modal-media'
		});

		modalInstance.result.then(function (data) {
			$scope.loadMedia();
		}, function () { });
	};

	$scope.openLightboxModal = function (index) {
		Lightbox.openModal($scope.mediaList, index);
	};

	$scope.downloadMedia = function (id) {
		MediaEditService
			.addDownload(id);
	};

	$rootScope.$on( 'media_deleted', function(event, data) {

	});

	function buildGridModel(medias, tileTmpl) {
		var it,
			results = [ ],
			j = 0;

		angular.forEach(medias, function(md) {

			it = angular.extend({}, tileTmpl);
			it.id      		= md.id;
			it.image   		= md.thumb;
			it.title  		= md.title ? md.title : md.orig_filename;
			it.type    		= ( md.type ? md.type : 'other');
			it.status  		= md.status;
			it.span    		= { row : 1, col : 1 };

			if ( j == 11 ) {
				j = 0;
			}

			switch ( j+1 ) {
				case 1:
					it.span.row = it.span.col = 2;
					break;
				case 4:
					it.span.col = 2;
					break;

				case 5:
					it.span.row = it.span.col = 2;
					break;
			}

			j++;

			results.push(it);
		});

		return results;
	}


	$scope.deleteMedia = function(mediaId)
	{
		var media = null;
		angular.forEach($scope.mediaList, function(m, key) {
			if ( m.id === mediaId ) {
				media = m;
			}
		});

		$confirm({
			title: 'Sei sicuro di voler eliminare questo media?',
			text: 'Confermi la cancellazione del media?'
		}).then(function() {

			$scope.showLoader();
			MediaDeleteService
				.delete( media.id  )
				.then(function() {
					$scope.hideLoader();

					angular.forEach($scope.mediaList, function(media, key) {
						if ( media.id === mediaId ) {
							$scope.mediaList.splice(key, 1);
						}
					});

					angular.forEach($scope.tiles, function(tile, key) {
						if ( tile.id === mediaId ) {
							$scope.tiles.splice(key, 1);
						}
					});

					$scope.showSuccessMsg('Media eliminato con successo!', '');
				});

		});
	};


	$scope.changeMediaStatus = function(mediaId)
	{
		var media = null;
		angular.forEach($scope.mediaList, function(m, key) {
			if ( m.id === mediaId ) {
				media = m;
			}
		});

		$scope.showLoader();

		var mediaData = {
			status: ( media.status === 'visible' ? 'hidden' : 'visible' )
		};

		MediaEditService
			.updateStatus( media.id, mediaData )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					angular.forEach($scope.mediaList, function(m, key) {
						if (m.id === mediaId) {
							$scope.mediaList[key] = data;
						}
					});

					angular.forEach($scope.tiles, function(t, key) {
						if (t.id === mediaId) {
							t.status = data.status;
							$scope.tiles[key] = t;
						}
					});

					$scope.showSuccessMsg('Media aggiornato con successo!', '');
				}
			});
	};

	$scope.showDelete = true;
	if ( sessionStorage.getItem('sub_from_admin_archive') ) {
		sessionStorage.removeItem('sub_from_admin_archive');
		$scope.showDelete = false;
	}

})


.controller('ModalMediaInstanceController',
	function (
		$scope, $stateParams,
		$uibModalInstance, FileUploader, getBaseApiURL, Session
	) {

	$scope.mediaData = {
		files: []
	};

	$scope.uploadDone = false;

	$scope.uploader = new FileUploader({
		alias: 'files',
		url: getBaseApiURL + '/media/upload',
		headers: {
			Authorization: 'Bearer ' + Session.token,
			Accept: 'application/json'
		}
	});

	$scope.uploader.formData.push({ 'event_id' : $stateParams.event_id });
	$scope.uploader.formData.push({ 'directory_id' : $stateParams.directory_id });

	$scope.uploader.onCompleteAll = function() {
		$scope.uploadDone = true;
	};

	$scope.createMedias = function () {
		$scope.uploader.uploadAll();
	};

	$scope.closeModal = function() {
		if ( $scope.uploadDone ) {
			$uibModalInstance.close();
		} else {
			$uibModalInstance.dismiss('cancel');
		}
	};

	$scope.triggerInput = function() {
		setTimeout(function() {
			document.getElementById('files').click()
		}, 0);
	};

})

.controller('LightboxController', function ($rootScope, $scope, Lightbox) {

});